export const TRANSLATIONS_TA = {
  login: {
    welcome: "வரவேற்பு",
    username: "பயனர் பெயர்",
    password: "கடவுச்சொல்",
    usernamePlaceholder: "பதிவு செய்யப்பட்ட மின்னஞ்சல் / பயனர் பெயர்",
    signIn: "உள்நுழைக",
    forgotPassword: "கடவுச்சொல்லை மறந்துவிட்டீர்களா",
    noAccount: "கணக்கு இல்லையா?",
    registerNow: "இப்போது பதிவு செய்யவும்",
    noUsername: "உங்கள் பயனர்பெயரை உள்ளிடவும்!",
    noPassword: "உங்கள் கடவுச்சொல்லை உள்ளிடவும்!",
  },
  register: {
    newUser: "புதிய பயனர்",
    registerHere: "இங்கே பதிவு செய்யவும்",
    email: "மின்னஞ்சல்",
    emailPlaceholder: "உங்கள் பதிவு செய்யப்பட்ட மின்னஞ்சலை உள்ளிடவும்",
    mobileNo: "அலைபேசி எண்",
    createPassword: "கடவுச்சொல்லை உருவாக்கு",
    confirmPassword: "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
    passwordAgain: "கடவுச்சொல்லை மீண்டும் உள்ளிடவும்",
    mobilePlease: "மொபைல் எண்",
    signUp: "பதிவு செய்யவும்",
    alreadyHaveAccount: "ஏற்கனவே ஒரு கணக்கு உள்ளதா!",
    signIn: "உள்நுழையவும்",
    noMobileNo: "உங்கள் மொபைல் எண்ணை உள்ளிடவும்!",
    noEmail: "தயவுசெய்து உங்கள் மின்னஞ்சலை உள்ளிடவும்!",
    noPassword: "உங்கள் கடவுச்சொல்லை உள்ளிடவும்!",
    noConfirmPassword: "உங்கள் உறுதிப்படுத்தல் கடவுச்சொல்லை உள்ளிடவும்!",
  },
  verify: {
    title: "OTP மூலம் சரிபார்க்கவும்",
    otpOn: "நாங்கள் OTP ஐ அனுப்பியுள்ளோம்",
    registeredEmail: "மற்றும் உங்கள் பதிவு செய்யப்பட்ட மின்னஞ்சல் முகவரி",
    codeNotReceived: "நான் குறியீட்டைப் பெறவில்லை.",
    resend: "மீண்டும் அனுப்பு",
    itOr: "அது அல்லது",
    details: "விவரங்கள்",
    changeRegistrationDetails: "பதிவு விவரங்களை மாற்றவும்",
    verify: "சரிபார்க்கவும்",
  },
};
